import React from 'react'
import Case from '@components/LocalMerchant/Case/Home'
import CaseExample from '@components/LocalMerchant/Case/CaseExample'
import CaseAdd from '@components/LocalMerchant/Case/CaseAdd'
import JiaMengHeader from '@components/JiaMeng/Header/Goods'
import Optimize from '@components/LocalMerchant/Case/Optimize'
import Order from '@components/LocalMerchant/Case/Order'
import Classify from '@components/LocalMerchant/Case/Classify'
import Introduce from '@components/LocalMerchant/Case/Introduce'
import ChooseProperty from '@components/LocalMerchant/Case/Publish/ChooseProperty'
import UnionPhoto from '@components/LocalMerchant/Case/UnionPhoto'
import { getRouteComponent } from '@util'
import { PRIVILEGE_STORE_ID, PRIVILEGE_STORE_SERVICE_ID } from '@constant'
import CaseDetail from '@components/LocalMerchant/Case/CaseDetail'
import AuditList from '@components/LocalMerchant/Case/AuditList'
import DraftList from '@components/LocalMerchant/Case/draftList'

export default {
  path: 'case',
  component: props => <JiaMengHeader key="cases" {...props} />,
  indexRoute: {
    component: Case
  },
  stat: '案例管理/首页',
  moduleName: '案例管理',
  childRoutes: [
    {
      path: 'order',
      component: Order,
      stat: '案例管理/案例排序'
    },
    {
      path: 'optimize',
      component: Optimize,
      stat: '案例管理/案例优化'
    },
    {
      path: 'classify',
      component: Classify,
      stat: '案例管理/案例分类'
    },
    {
      path: 'publish/chooseProperty',
      getComponent: getRouteComponent(ChooseProperty, {
        role: [PRIVILEGE_STORE_ID, PRIVILEGE_STORE_SERVICE_ID]
      })
    },
    {
      path: 'introduce',
      component: Introduce,
      stat: '案例管理/关联客照',
      title: '关联客照'
    },
    {
      path: 'unionPhoto/:id',
      component: UnionPhoto,
      stat: '案例管理/关联客照',
      title: '关联客照'
    },
    {
      path: 'add',
      component: CaseAdd,
      stat: '案例管理/发布案例'
    },
    {
      path: 'detail/:id',
      component: CaseDetail,
      stat: '案例管理/编辑案例'
    },
    {
      path: 'example(/:propertyId)',
      component: CaseExample,
      stat: '案例管理/查看样例'
    },
    {
      path: 'auditList',
      component: AuditList,
      stat: '案例管理/案例审核记录',
      title: '案例审核记录'
    },
    {
      path: 'draftList',
      component: DraftList,
      stat: '案例管理/草稿箱',
      title: '草稿箱'
    }
  ]
}
